import { render, staticRenderFns } from "./Followtestdetail-child5.vue?vue&type=template&id=172799e4&scoped=true"
import script from "./Followtestdetail-child5.vue?vue&type=script&lang=js"
export * from "./Followtestdetail-child5.vue?vue&type=script&lang=js"
import style0 from "./Followtestdetail-child5.vue?vue&type=style&index=0&id=172799e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172799e4",
  null
  
)

export default component.exports